import React from "react";
export default function Nl2Br({ children }) {
  if (!children.split) return children;
  return (
    <React.Fragment>
      {children.split("\n").map((line, idx) => (
        <React.Fragment key={idx}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}
